import { AboutHero, MissionVision, BecFramework, CeptModel } from '@/components/sections/about'
import { FinalCTA } from '@/components/sections'
import { usePageTitle } from '@/hooks'

export const AboutPage = () => {
  usePageTitle('About Us')

  return (
    <>
      <AboutHero />
      <MissionVision />
      <BecFramework />
      <CeptModel />
      <FinalCTA />
    </>
  )
}
